import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRecentWorkshops } from '../../../../api/workshop/workshop.api';
import { useDashboardBreakpoint } from '@repo/common';

const Workshops = () => {
  const navigate = useNavigate();
  const bp = useDashboardBreakpoint();

  const [workshops, setWorkshops] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  const isDesktop = ['desktopS', 'desktopL'].includes(bp);
  const isTablet = bp === 'tabletV';
  const isMobile = ['mobileMini', 'mobile', 'tabletH'].includes(bp);
  const displayedWorkshops = isTablet ? workshops.slice(0, 2) : workshops;

  const handleWorkshopClick = (workshopId) => {
    navigate(`/community/kpathport/workshop/${workshopId}`);
  };

  useEffect(() => {
    const fetchRecentWorkshops = async () => {
      try {
        const data = await getRecentWorkshops();
        setWorkshops(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchRecentWorkshops();
  }, []);

  useEffect(() => {
    if (workshops.length === 0 || isPaused) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % workshops.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [workshops, isPaused]);

  return (
    <div
      className={`flex ${isDesktop || isMobile ? 'flex-col' : 'flex-row'} ${
        isMobile && 'pt-9 pb-[54px]'
      } items-start gap-2 w-full h-full`}
    >
      {displayedWorkshops.map((workshop, index) => (
        <div
          key={workshop.id}
          onClick={() => handleWorkshopClick(workshop.id)}
          onMouseEnter={() => {
            if (isTablet) return;
            setActiveIndex(null);
            setHoveredIndex(index);
            setIsPaused(true);
          }}
          onMouseLeave={() => {
            if (isTablet) return;
            setActiveIndex(hoveredIndex);
            setHoveredIndex(null);
            setIsPaused(false);
          }}
          className={`relative flex overflow-hidden cursor-pointer transition-all duration-300 bg-grayscale-gray00 ${
            isTablet
              ? 'flex-col items-start justify-start gap-2 p-3 rounded-[24px] flex-1 min-w-0 self-stretch'
              : activeIndex === index || hoveredIndex === index
                ? 'w-full rounded-[20px] flex-1 min-h-[200px]'
                : 'w-full rounded-[15px] flex-shrink-0 min-h-[84px]'
          }`}
          style={{ border: '1.6px solid #c6f9e9' }}
        >
          {isTablet ? (
            <>
              <div className='relative min-w-0 w-full h-[131px] rounded-[16px] overflow-hidden flex-shrink-0'>
                <img
                  src={workshop.thumbnailImage}
                  alt='workshop'
                  className='object-cover object-center w-full h-full'
                />
                <div
                  className='absolute inset-0'
                  style={{ background: 'rgba(23, 20, 16, 0.20)' }}
                />
              </div>
              <div className='flex flex-col items-start gap-0.5 w-full overflow-hidden px-2'>
                <div className='typo-b14Strong text-text-tertiary line-clamp-1'>
                  {workshop.title}
                </div>
                <div className='typo-b12 text-text-placeholder line-clamp-1'>
                  {workshop.meetingPointName}
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                className={`absolute inset-0 flex pl-2 pr-4 py-2 gap-3 items-center transition-opacity duration-300 ${
                  (isDesktop || isMobile) &&
                  (activeIndex === index || hoveredIndex === index)
                    ? 'opacity-0'
                    : 'opacity-100'
                }`}
              >
                <div className='relative size-[60px] min-w-[60px] rounded-[10px] overflow-hidden flex-shrink-0'>
                  <img
                    src={workshop.thumbnailImage}
                    alt='default profile'
                    className='object-cover size-full'
                  />
                  <div className='absolute inset-0' style={{ background: 'rgba(23, 20, 16, 0.20)' }} />
                </div>
                <div className='flex flex-col items-start justify-center overflow-hidden'>
                  <div className='typo-b16Strong text-text-tertiary line-clamp-1'>
                    {workshop.title}
                  </div>
                  <div className='typo-b12 text-text-placeholder'>
                    {workshop.meetingPointName}
                  </div>
                </div>
              </div>

              <div
                className={`absolute inset-0 flex flex-col px-2 pt-4 pb-2 gap-4 transition-opacity duration-300 ${
                  (isDesktop || isMobile) &&
                  (activeIndex === index || hoveredIndex === index)
                    ? 'opacity-100'
                    : 'opacity-0'
                }`}
              >
                <div className='flex flex-col items-start flex-shrink-0 w-full px-3 overflow-hidden'>
                  <div className='w-full typo-b18Strong text-text-tertiary'>
                    {workshop.title}
                  </div>
                  <div className='typo-b12 text-text-placeholder'>
                    {workshop.meetingPointName}
                  </div>
                </div>
                <div className='relative flex-1 w-full min-h-0 rounded-[13px] overflow-hidden'>
                  <img
                    src={workshop.thumbnailImage}
                    alt='workshop thumbnail'
                    className='object-cover object-center w-full h-full'
                  />
                  <div className='absolute inset-0' style={{ background: 'rgba(23, 20, 16, 0.15)', boxShadow: 'inset 0px 0px 20px 0px rgba(88, 88, 88, 0.4)' }} />
                </div>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default Workshops;
